import React from 'react';
import axios from 'axios';

const newsApiBaseUrl = 'https://lrfiosxbs6.execute-api.ap-northeast-2.amazonaws.com';
const newsImageBaseUrl = 'https://d1aummmer0n4kg.cloudfront.net/media/';

class AdminNewsManager extends React.Component {
  state = {
    mode: 'list',
    page: 1,
    pageSize: 10,
    newsItems: [],
    isListLoading: true,
    isSubmitting: false,
    errorMessage: '',
    form: {
      id: null,
      title: '',
      content: '',
      created: '',
      imageFile: null,
      imagePreview: ''
    }
  }

  componentDidMount() {
    this.fetchNewsList();
    window.addEventListener('popstate', this.handlePopState);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);

    if (this.errorToastTimer) {
      clearTimeout(this.errorToastTimer);
    }
  }

  handlePopState = (event) => {
    if (event.state && event.state.adminNewsForm) {
      return;
    }

    this.setState({ mode: 'list', errorMessage: '' });
  }

  showErrorToast = (message) => {
    if (this.errorToastTimer) {
      clearTimeout(this.errorToastTimer);
    }

    this.setState({ errorMessage: message });
    this.errorToastTimer = setTimeout(() => {
      this.setState({ errorMessage: '' });
    }, 3000);
  }

  fetchNewsList = () => {
    const { page } = this.state;

    this.setState({ isListLoading: true });

    axios.get(`${newsApiBaseUrl}/default/news`, {
      params: {
        page
      }
    })
      .then((response) => {
        console.log('News list response', response.data);
        this.setState({
          page: response.data.page || page,
          pageSize: response.data.page_size || 10,
          newsItems: response.data.items || [],
          isListLoading: false
        });
      })
      .catch((error) => {
        console.error('News list request failed', error);
        this.setState({ isListLoading: false });
      });
  }

  goToPage = (nextPage) => {
    if (nextPage < 1) {
      return;
    }

    this.setState({
      page: nextPage
    }, this.fetchNewsList);
  }

  openCreateForm = () => {
    window.history.pushState({ adminNewsForm: true, mode: 'create' }, '');
    this.setState({
      mode: 'form',
      errorMessage: '',
      form: {
        id: null,
        title: '',
        content: '',
        created: '',
        imageFile: null,
        imagePreview: ''
      }
    });
  }

  openEditForm = (item) => {
    window.history.pushState({ adminNewsForm: true, mode: 'edit', id: item.id }, '');
    this.setState({
      mode: 'form',
      errorMessage: '',
      form: {
        id: item.id,
        title: item.title,
        content: item.content,
        created: item.created,
        imageFile: null,
        imagePreview: item.image ? `${newsImageBaseUrl}${item.image}` : ''
      }
    });
  }

  closeForm = () => {
    if (window.history.state && window.history.state.adminNewsForm) {
      window.history.back();
      return;
    }

    this.setState({ mode: 'list' });
  }

  handleFormChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value
      }
    }));
  }

  handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        imageFile: file,
        imagePreview: file ? URL.createObjectURL(file) : prevState.form.imagePreview
      }
    }));
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.form.id) {
      this.submitEditNews();
      return;
    }

    this.submitCreateNews();
  }

  handleDelete = () => {
    this.submitDeleteNews();
  }

  fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = typeof reader.result === 'string' ? reader.result : '';
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  })

  buildNewsPayload = async () => {
    const { title, content, created, imageFile } = this.state.form;

    const payload = {
      title,
      content,
      timestamp: created,
      image_base64: '',
      image_content_type: '',
      image_filename: ''
    };

    if (imageFile) {
      payload.image_base64 = await this.fileToBase64(imageFile);
      payload.image_content_type = imageFile.type;
      payload.image_filename = imageFile.name;
    }

    return payload;
  }

  submitCreateNews = async () => {
    const token = localStorage.getItem('access_token');

    this.setState({ isSubmitting: true });

    try {
      const payload = await this.buildNewsPayload();

      console.log('News create payload', payload);

      const response = await axios.post(`${newsApiBaseUrl}/default/news`, payload, {
        headers: {
          token
        }
      });
      console.log('News create response', response.data);

      this.setState({
        isSubmitting: false,
        mode: 'list',
        form: {
          id: null,
          title: '',
          content: '',
          created: '',
          imageFile: null,
          imagePreview: ''
        }
      }, this.fetchNewsList);
    } catch (error) {
      console.error('News create request failed', error);
      this.setState({ isSubmitting: false });
      this.showErrorToast('추가 중 오류가 발생했습니다.');
    }
  }

  submitEditNews = async () => {
    const { id } = this.state.form;
    const token = localStorage.getItem('access_token');

    this.setState({ isSubmitting: true });

    try {
      const payload = await this.buildNewsPayload();

      console.log('News edit payload', payload);

      const response = await axios.put(`${newsApiBaseUrl}/default/news/${id}`, payload, {
        headers: {
          token
        }
      });
      console.log('News edit response', response.data);

      this.setState({
        isSubmitting: false,
        mode: 'list',
        form: {
          id: null,
          title: '',
          content: '',
          created: '',
          imageFile: null,
          imagePreview: ''
        }
      }, this.fetchNewsList);
    } catch (error) {
      console.error('News edit request failed', error);
      this.setState({ isSubmitting: false });
      this.showErrorToast('수정 중 오류가 발생했습니다.');
    }
  }

  submitDeleteNews = async () => {
    const { id } = this.state.form;
    const token = localStorage.getItem('access_token');

    if (!id) {
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      console.log('News delete payload', { id });

      const response = await axios.delete(`${newsApiBaseUrl}/default/news/${id}`, {
        headers: {
          token
        }
      });
      console.log('News delete response', response.data);

      this.setState({
        isSubmitting: false,
        mode: 'list',
        form: {
          id: null,
          title: '',
          content: '',
          created: '',
          imageFile: null,
          imagePreview: ''
        }
      }, this.fetchNewsList);
    } catch (error) {
      console.error('News delete request failed', error);
      this.setState({ isSubmitting: false });
      this.showErrorToast('삭제 중 오류가 발생했습니다.');
    }
  }

  truncateContent = (content) => {
    if (!content || content.length <= 12) {
      return content;
    }

    return `${content.slice(0, 12)}...`;
  }

  renderList() {
    const { newsItems, page, pageSize, isListLoading } = this.state;
    const hasNextPage = newsItems.length === pageSize;

    if (isListLoading) {
      return (
        <div className="public-content-loading">
          <div className="public-content-spinner" />
        </div>
      );
    }

    return (
      <>
        <div className="admin-news-header">
          <div>
            <div className="admin-panel-eyebrow">Editor</div>
            <h2 className="admin-panel-title">News</h2>
          </div>
          <button type="button" className="admin-news-add-button" onClick={this.openCreateForm}>추가</button>
        </div>

        <div className="admin-news-table-wrapper">
          <table className="admin-news-table">
            <thead>
              <tr>
                <th>title</th>
                <th>image</th>
                <th>content</th>
                <th>created</th>
              </tr>
            </thead>
            <tbody>
              {newsItems.map((item) => (
                <tr key={item.id} className="admin-news-row" onClick={() => this.openEditForm(item)}>
                  <td>{item.title}</td>
                  <td>
                    {item.image ? (
                      <img
                        className="admin-news-thumbnail"
                        src={`${newsImageBaseUrl}${item.image}`}
                        alt={item.title}
                      />
                    ) : null}
                  </td>
                  <td>{this.truncateContent(item.content)}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="admin-news-pagination">
          <button
            type="button"
            className="admin-news-secondary-button"
            onClick={() => this.goToPage(page - 1)}
            disabled={page <= 1}
          >
            이전
          </button>
          <span className="admin-news-page-indicator">Page {page}</span>
          <button
            type="button"
            className="admin-news-secondary-button"
            onClick={() => this.goToPage(page + 1)}
            disabled={!hasNextPage}
          >
            다음
          </button>
        </div>
      </>
    );
  }

  renderForm() {
    const { id, title, content, created, imagePreview, imageFile } = this.state.form;
    const { isSubmitting, errorMessage } = this.state;

    return (
      <>
        <div className="admin-news-header">
          <div>
            <div className="admin-panel-eyebrow">Editor</div>
            <h2 className="admin-panel-title">{id ? 'News 수정' : 'News 추가'}</h2>
          </div>
          <button type="button" className="admin-news-secondary-button" onClick={this.closeForm}>목록으로</button>
        </div>

        {errorMessage ? (
          <div className="admin-error-toast">{errorMessage}</div>
        ) : null}

        <form className="admin-news-form" onSubmit={this.handleSubmit}>
          <label className="admin-news-field">
            <span>title</span>
            <input
              className="admin-news-input"
              name="title"
              type="text"
              value={title}
              onChange={this.handleFormChange}
            />
          </label>

          <label className="admin-news-field">
            <span>content</span>
            <textarea
              className="admin-news-textarea"
              name="content"
              value={content}
              onChange={this.handleFormChange}
              rows="8"
            />
          </label>

          <label className="admin-news-field">
            <span>created</span>
            <input
              className="admin-news-input"
              name="created"
              type="date"
              value={created}
              onChange={this.handleFormChange}
            />
          </label>

          <label className="admin-news-field">
            <span>image</span>
            <input
              className="admin-news-input"
              type="file"
              accept="image/*"
              onChange={this.handleImageChange}
            />
          </label>

          {imagePreview ? (
            <div className="admin-news-preview">
              <img className="admin-news-preview-image" src={imagePreview} alt="news preview" />
              {imageFile ? <div className="admin-news-preview-name">{imageFile.name}</div> : null}
            </div>
          ) : null}

          <div className="admin-news-form-actions">
            <div>
              {id ? (
                <button type="button" className="admin-news-delete-button" onClick={this.handleDelete}>삭제</button>
              ) : null}
            </div>
            <div className="admin-news-form-actions-right">
              {isSubmitting ? (
                <div className="admin-inline-spinner public-content-spinner" />
              ) : null}
              <button type="button" className="admin-news-secondary-button" onClick={this.closeForm}>취소</button>
              <button type="submit" className="admin-news-add-button" disabled={isSubmitting}>
                {id ? '수정하기' : '추가하기'}
              </button>
            </div>
          </div>
        </form>
      </>
    );
  }

  render() {
    return (
      <div className="admin-panel-card">
        {this.state.mode === 'list' ? this.renderList() : this.renderForm()}
      </div>
    );
  }
}

export default AdminNewsManager;
